import React, { useState, useEffect } from "react";
import { Navbar, Image, Form, FormControl } from "react-bootstrap";
import GenericExplorer from "../generic/GenericExplorer";
import ProvinciaTarjeta from "./ProvinciaTarjeta";
// Styled Components
import styled from "styled-components";
import TooltipIcon from "../generic/TooltipIcon";

const CustomNavBar = styled(Navbar)`
  min-width: 200px;
`;

const Provincias = ({ ...props }) => {
  const [search, setSearch] = useState("");
  const [todasProvincias, setTodasProvincias] = useState(false);
  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };
  // A partir de los valores de los filtros obtiene el query string
  const getQueryString = () => {
    let count = "30";
    let findName = search ? search : "";

    return `?count=${count}&findName=${findName}&ended=${todasProvincias}`;
  };

  const handleTodasProvincias = () => {
    setTodasProvincias(!todasProvincias)
  }

  return (
    <>
      <h2>Provincias</h2>
      {
      //console.log(`/provincias${getQueryString()}`)
    }
      <GenericExplorer url={`/provincias${getQueryString()}`} userLevel={props.userLevel} provinciaLogueado={props.provinciaLogueado} ItemCard={ProvinciaTarjeta}>
        <CustomNavBar expand="md">
          {/* Cuando se hace pequeña la pantalla */}
          <Navbar.Toggle aria-controls="Filtro Hermanas" className="bg-light mb-3">
            <Image className="align-text-top" alt="" height="20" />
            <span className="align-text-bottom"> Filtros</span>
          </Navbar.Toggle>
          {/*          */}
          <Navbar.Collapse className="mb-3" id="basic-navbar-nav">
          <Form.Group>
            <Form as="div" inline className="w-100">
              
              <FormControl type="text" onChange={handleChangeSearch} placeholder={"Búsqueda"} className="mr-3" />
              
                  <Form.Check type="checkbox" label="Todas las provincias" defaultChecked={todasProvincias} value={todasProvincias} onClick={handleTodasProvincias} />
                  <TooltipIcon className={"ml-1 pb-1"} content={"Al seleccionar esta opción se muestran las provincias suprimidas a lo largo del tiempo"} />
                
            </Form>
            </Form.Group>
          </Navbar.Collapse>
          
        </CustomNavBar>
      </GenericExplorer>
    </>
  );
};

export default Provincias;
